import { hasText } from 'shared/lib/common-util'
import { RuleResult } from '../../../../types/DeclarationP5'

/**
 * This rule is added only for documentation purposes, because entry indicator value is always present and is never undefined.
 * Therefore, re-entry indicator is always REQUIRED.
 */
const C0144Validator = {
  validateCustomsOfficeOfTransitReEntryIndicatorRequirement: ({
    entryIndicator,
  } : {
    entryIndicator?: string
  }): RuleResult => (hasText(entryIndicator) ? 'REQUIRED' : 'NOT_ALLOWED'),
}

export default C0144Validator
